var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5691 64.3216C55.9853 72.9916 63.0397 80.0371 71.7173 84.4483L78.4455 77.7063C79.2892 76.8626 80.4918 76.622 81.5495 76.9583C84.9659 78.0878 88.6518 78.7011 92.4573 78.7011C94.1535 78.7011 95.5147 80.0623 95.5147 81.7586V92.4585C95.5147 94.1547 94.1535 95.516 92.4573 95.516C63.7487 95.516 40.4851 72.2537 40.4851 43.5438C40.4851 41.8564 41.8552 40.4863 43.5426 40.4863H54.2425C55.9387 40.4863 57.3 41.8476 57.3 43.5438C57.3 47.3493 57.9133 51.0364 59.0428 54.4578C59.379 55.5093 59.1385 56.7207 58.2948 57.5644L51.5691 64.3228V64.3216Z",
    fill: "#73151F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.1b805ef155921ad1c0d0db864d014e8d.svg";
export { ForwardRef as ReactComponent };